import { Controller } from 'stimulus'
import moveable from '../../../library/moveable'

export default class extends Controller {
  connect() {
    moveable()
  }
}